@import './pn-site-footer-common.scss';
@import '../../../globals/main.scss';

pn-site-footer:not([theme='dotcom']) {
  display: block;
  line-height: 1.5;
  a {
    color: $blue700;
    &:hover {
      color: $blue900;
      text-decoration: underline;
    }
  }

  h3 {
    font-size: 2.4rem;
    margin-bottom: 0.5rem;
    line-height: 1.2;
  }
  p {
    font-size: 1.6rem;
  }

  pn-site-footer-col ul.social-media {
    display: flex;
    flex-flow: row;
    gap: 1.6rem;
    row-gap: 1.2rem;
    margin-bottom: 1.6rem;
    flex-wrap: wrap;

    li {
      margin-bottom: 0;
    }
  }
  > svg {
    display: block;
  }
  > div {
    background: $gray50;
  }

  .pn-sitefooter-top {
    display: flex;
  }

  .pn-sitefooter-cols {
    align-self: center;
    justify-content: center;
    display: block;
    flex-flow: row wrap;
    margin: 0 auto;
    max-width: 90em;

    @media screen and (min-width: $sitefooter-media-phoneheight) {
      display: flex;
    }
  }

  .pn-sitefooter-bottom [slot='bottom'] {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    max-width: 90em;
    margin: 0 auto;
    padding: 1.6rem 0;
    border-top: 1px solid $gray200;
    border-bottom: 1px solid $gray200;

    span,
    a {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      align-items: center;
    }

    a {
      text-decoration: underline !important;
    }

    @media screen and (min-width: $min-width-md) {
      gap: 0;
      flex-direction: row;
      
      span,
      a {
        flex-direction: row;
        align-items: flex-start;
        line-height: 2;
        margin: 0 1.6rem;
        text-decoration: none;
      }
    }

    li {
      line-height: 2em;
      margin: 0 1.6rem;
    }
  }

  .pn-sitefooter-logo {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 3rem;
    svg {
      display: block;
      width: 13.3rem;
      height: 2.6rem;
    }
    &:has(div) a slot-fb {
      display: none;
    }
  }
}

pn-site-footer[theme='dotcom'] {
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: $blue900;
  margin: 0 auto;

  & > svg {
    background-color: $white;
    path {
      fill: $blue900;
    }
  }

  .pn-sitefooter-top {
    width: 100%;
    position: relative;
    top: -1px;

    background-color: $blue900;

    .pn-sitefooter-cols {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-top: 4.8rem;
      padding-left: 3rem;
      padding-right: 3rem;

      margin: 0 auto;

      @media screen and (min-width: $min-width-md) {
        max-width: 72rem;
      }

      @media screen and (min-width: $min-width-lg) {
        max-width: 96rem;
        padding-left: 0;
        padding-right: 0;
      }

      @media screen and (min-width: $min-width-xl) {
        max-width: 114rem;
      }

      @media screen and (min-width: $min-width-xxl) {
        max-width: 144rem;
      }

      h3 {
        font-weight: 500;
      }

      a:hover {
        text-decoration: underline;
        color: $white;
      }
    }
  }

  .pn-sitefooter-bottom {
    width: 100%;
    padding: 0.8rem 0;
    background-color: $blue900;

    & > [slot='bottom'] {
      max-width: 120rem;
      margin: 0 auto;
      padding-left: .8rem;
      padding-right: .8rem;

      @media screen and (min-width: $min-width-md) {
        padding-left: 3rem;
        padding-right: 3rem;
      }

      display: flex;
      flex-direction: column;
      gap: 2.4rem;

      & > .social-media {
        display: flex;
        justify-content: center;

        padding: 1.6rem 0;
        border-top: 1px solid #005d924d;
        border-bottom: 1px solid #005d924d;

        & > ul {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          gap: 2.4rem;

          margin: 0;
          padding: 0;
          list-style-type: none;

          & > li:hover {
            svg > circle {
              fill: $blue700;
            }
          }
        }
      }

      & > .copyright {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 1rem;

        a {
          text-decoration: underline;

          &:hover {
            text-decoration: none;
          }
        }
        
        @media screen and (min-width: $min-width-md) {
          flex-direction: row;
          gap: 2.4rem;
        }

        & * {
          display: flex;
          align-items: center;
          color: $white;
          font-weight: 400;
          font-size: 1.4rem;
          line-height: 1.96rem;
          min-height: 26px;
        }
        
        & > ul {
          margin: 0;
          padding: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 1rem;

          @media screen and (min-width: $min-width-md) {
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
          }

          & > li {
            display: inline;
            &:first-child {
              margin-left: 0;
            }
            @media screen and (min-width: $min-width-md) {
              margin-left: 2.4rem;
            }
          }
        }
      }
    }
  }

  .pn-sitefooter-logo {
    padding: 3rem;
    margin: 0 auto;
    [name='logo'] {
      & > svg {
        display: block;
        width: 13.3rem;
        height: 2.6rem;
        & > path {
          fill: $blue400;
        }
      }
    }
  }
}
